import { Box, Button, Container, Stack, Typography } from '@mui/material';
import PhotoRoundedIcon from '@mui/icons-material/PhotoRounded';
import { Link } from 'react-router-dom';
import { useT } from '../../i18n';
import { ResidentDownloadButton } from './ResidentDownloadButton';

export function Hero() {
  const t = useT();

  return (
    <Box component="section" sx={{ bgcolor: 'background.default', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1.05fr 0.95fr' },
            gap: { xs: 4, md: 6 },
            alignItems: 'center',
          }}
        >
          <Box>
            <Typography
              variant="overline"
              sx={{ color: 'secondary.main', fontWeight: 600, letterSpacing: '0.6px' }}
            >
              {t('landing.hero.kicker')}
            </Typography>
            <Typography variant="h2" fontWeight={700} sx={{ mt: 1, letterSpacing: '-0.5px' }}>
              {t('landing.hero.title')}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 2, maxWidth: 520 }}>
              {t('landing.hero.sub')}
            </Typography>
            <Stack direction="row" spacing={2} sx={{ mt: 4, flexWrap: 'wrap', rowGap: 2 }}>
              <Button size="large" variant="contained" color="primary" component={Link} to="/login">
                {t('landing.hero.ctaLogin')}
              </Button>
              <ResidentDownloadButton />
            </Stack>
          </Box>

          {/* Hero image slot. Drop a real photo at admin/public/landing/hero.jpg and
              swap this placeholder for an <img src="/landing/hero.jpg" .../>. */}
          <Box
            sx={{
              minHeight: { xs: 200, md: 320 },
              borderRadius: 3,
              bgcolor: 'action.hover',
              border: 1,
              borderColor: 'divider',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'text.disabled',
              gap: 1,
            }}
          >
            <PhotoRoundedIcon sx={{ fontSize: 40 }} />
            <Typography variant="caption">{t('landing.hero.imageAlt')}</Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
